import React, { Fragment } from "react";
import Label from "./Label";

const CheckBox = props => {
  const {
    name,
    required,
    label,
    helpText,
    selectedOptions,
    options,
    onChange
  } = props;
  return (
    <Fragment>
      <Label htmlFor={name} helpText={helpText} required={required}>
        {label}
      </Label>
      <>
        {options.map((option, i) => {
          const inputId = `${name}-${i}`;

          let id, description;
          if (typeof option === "string") {
            [id, description] = [option, option];
          } else {
            // assume it's an object of shape { id: 1, description: 'something' }
            ({ id, description } = option);
            id = String(id);
          }

          return (
            <div className="form-check" key={inputId}>
              <input
                id={inputId}
                name={name}
                className="form-check-input"
                onChange={onChange}
                value={id}
                defaultChecked={false}
                checked={selectedOptions && selectedOptions.indexOf(id) > -1}
                type="checkbox"
              />
              <label className="form-check-label" htmlFor={inputId}>{description}</label>
            </div>
          );
        })}
      </>
    </Fragment>
  );
};

export default CheckBox;
